import { render, staticRenderFns } from "./CreateChannelSubAccount.vue?vue&type=template&id=6db83314&scoped=true&"
import script from "./CreateChannelSubAccount.vue?vue&type=script&lang=js&"
export * from "./CreateChannelSubAccount.vue?vue&type=script&lang=js&"
import style0 from "./CreateChannelSubAccount.vue?vue&type=style&index=0&id=6db83314&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6db83314",
  null
  
)

export default component.exports